export default __webpack_public_path__ + "static/media/Monitors.a2cd084a.md";